<!--
Component that connects directly to the cut plan store for filtering LOTS and PURCHASES for selected entries
-->

<template>
  <v-autocomplete
    :value="getLotFilters"
    @input="setLotFilters"
    :items="getAllLots"
    item-text="name"
    item-value="url"
    label="Filter by Lot"
    multiple
    clearable
  />
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'

export default {
  name: 'CutPlanLotFilter',
  computed: {
    ...mapGetters('cutPlanStore', [
      'getAllLots',
      'getLotFilters'
    ])
  },
  methods: {
    ...mapMutations('cutPlanStore', [
      'setLotFilters'
    ])
  }
}
</script>
